import {reactive, watch} from 'vue'
import router from "@/router";

const store = reactive([])

const add = (route) => {
	let backPathIndex = store.findIndex(item => item.fullPath === router.options.history.state.back)
	let target = store.find((item) => item.fullPath === route.fullPath)
	let isName = route.name
	if (!target && isName) {
		if (backPathIndex === -1) {
			store.push(route)
		} else {
			store.splice(backPathIndex + 1, 0, route)
		}
	}
}
const remove = (route) => {
	store.forEach((item, index) => {
		if (item.fullPath === route.fullPath) {
			store.splice(index, 1)
		}
	})
}
const update = (route) => {
	store.forEach((item) => {
		if (item.fullPath === route.fullPath) {
			Object.assign(item, route)
		}
	})
}
const updateTitle = (title = '') => {
	const nowFullPath = location.hash.substring(1)
	store.forEach((item) => {
		if (item.fullPath === nowFullPath) {
			item.meta.title = title
		}
	})
}
const clear = () => {
	store.length = 0
}

export const useViewTags = () => ({
	add, remove, update, updateTitle, clear,tags:store
})
